import './nestedCard.css';
import { INestedCard } from './INestedCard';
import { Card, CardContent, Grid } from '@mui/material';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowLeftRoundedIcon from '@mui/icons-material/ArrowLeftRounded';
export default function NestedCard({ outPart, inPart, onClick, isError }: INestedCard) {
    return (
        <Grid
            container
            xs={12}
            className={` p-3 ${isError ? 'bg-[var(--input-bg-color)]' : 'bgSecondaryErrorColorLight '} sayadBorder `}
            sx={{ borderRadius: '5px' }}
            onClick={() => onClick!()}
        >
            <Grid
                item
                xs={12}
                textAlign={'center'}
                className="!pb-2 primaryColorLight-900"
                container
            >
                <Grid sx={{ paddingRight: '.3em', paddingTop: '.7em' }} xs={11} textAlign={'right'}>
                    {outPart}
                </Grid>
                <Grid xs={1} textAlign={'left'} sx={{ paddingLeft: '.3em', paddingTop: '.7em' }}>
                    <ArrowLeftRoundedIcon
                        className={
                            isError
                                ? 'secondaryColorLight-600 '
                                : 'primaryErrorColorLight '
                        }
                    />
                </Grid>
            </Grid>
            <Grid
                item
                xs={12}
                textAlign={'center'}
                className={'!p-4 primaryColorLight-900 inPart sayadBorder'}
                sx={{
                    margin: 'auto',
                    borderRadius: '5px',
                }}
            >
                {inPart}
            </Grid>
        </Grid>
    );
}
